import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
  className?: string
}

const IconHistory: React.FC<Props> = ({
  width = '24px',
  height = '24px',
  fill = '#333',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z"
        fill={fill}
        opacity={0.3}
        strokeWidth={2}
      />

      <path
        d="M512 96c229.8 0 416 186.2 416 416S741.8 928 512 928 96 741.8 96 512 282.2 96 512 96m0-32C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z"
        fill={fill}
        strokeWidth={2}
      />

      <path
        d="M688 560.6L528 456V304a24 24 0 0 0-48 0v176c0 8.2 4.4 16 11.6 20.2l192 116.6a24 24 0 1 0 24.8-40z"
        fill={fill}
        strokeWidth={2}
      />
    </svg>
  )
}


export default IconHistory